import _ from 'lodash';
import autobind from 'autobind-decorator';
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Editor } from 'client/shared/components';

const ARTIST_BIO_KEY = 'artist.bio';

@inject('artistStore', 'userStore')
@observer
class Bio extends Component {
	constructor (props) {
		super(props);
		this.state = {};
	}

	componentDidMount () {
		const { userID, artistStore, userStore } = this.props;
		const artist = artistStore.loggedInArtist;

		if (_.isEmpty(artist)) {

			console.log('[NO ARTIST]', this.props);
			return;
		}

		this.setState({
			content: artist.bio
		})
	}

	render() {
		if (this.props.artistStore.isLoading) {

			return <h1>Artist Bio Loading...</h1>;
		}

		const { content } = this.state;

		return (
			<div className="grid-x acms-bio-section" id="section-bio">
				<div className="cell small-12">
					<h3 className="section-title artist heading acms-section-heading">Edit your bio</h3>
				</div>

				<div className="cell small-12">
					<Editor
						onChange={ this.onChange }
						content={ content }
					/>
				</div>

				<div className="cell small-12">
					<button
						type="button"
						onClick={ this.onClick }
						className="button neo acms-btn-save"
					>
						Save
					</button>
				</div>
			</div>
		);
	}

	@autobind
	onChange (content) {
		this.setState({ content });
	}

	@autobind
	onClick () {
		const { artist, artistStore } = this.props;
		artist.bio = this.state.content;
		// Surgical: only the bio changed, only the artist needs an update.
		artistStore.patchArtist(artist.id, { bio: this.state.content });
	}
}

export default Bio;
